// extracted by mini-css-extract-plugin
export default {"parcialEstatus":"History_parcialEstatus__Xo5TQ","failedEstatus":"History_failedEstatus__cXW93"};